//
// NetworkImageEvent.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "../network/NetworkDataEvent";

var NetworkImageEvent = createModule("commons::NetworkImageEvent", ["commons::PortableEvent","commons::NetworkDataEvent"], ClosetObject, [
    ,
    ,
    ,
    {
        size: 13,
        textureID: 3,
    },
    ,
    ,
    ,
]);
export default NetworkImageEvent;
